import * as types from "../../mutation-types.js";
import http from "@service/http";
import { tokenCall, restCall } from "@service/adapter";
import util from "@common/utils/util";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";

/**
 * 实体店 STORE
 */
export default {
  state: {
    loginType: "", //当前登录方式 PWD|MOBILE
  },
  actions: {
    updateLoginType(state, val) {
      state.loginType = val;
    },
    //获取问卷调查内容
    getPaperByCode({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/oa/simPaper/getPaperByCode",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //保存售后问卷调查的内容
    commitPaper({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/oa/simPaper/commitPaper",
        data,
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //保存大区问卷调查的内容
    commitPaperArea({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/oa/simPaper/commit",
        data.data,
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取验证码mxoa/sm/sendAuthCode
    sendAuthCode({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sm/sendAuthCode",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //提交手机号验证mxoa/sm/checkAuthCode
    checkAuthCode({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/sm/checkAuthCode",
        data,
        "get"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //校验是否可以注册
    checkRegisterable({ commit }, phoneNum) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.checkRegisterable",
          param: [phoneNum],
        })
        .then((result) => {
          if (result && result.success) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject((result && result.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    memSendAuthCodeSms({ commit }, mobileInfo) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.sendAuthCodeSms",
          param: mobileInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //忘记密码
    doSetLoginPwdByMobile({ commit }, setInfo) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.doSetLoginPwdByMobile",
          param: setInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //注册
    memRegister({ commit }, memRegisterInfo) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.saleMemRegister",
          param: memRegisterInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取登录/注册tooken
    getLoginToken({ commit }, data) {
      let url = Constant.authBaseUrl;
      return restCall(url, data)
        .then((res) => {
          if (res && res.success && res.target && res.target.success) {
            return Promise.resolve(res.target.target);
          } else {
            return Promise.reject(
              (res && (res.message || (res.target && res.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //登陆USR SESSION
    loginUsrSession(
      { commit },
      { openid, islogend, regnode, memdata, userAttrId }
    ) {
      let data = {
        openid: openid,
        islogend: islogend,
        memdata: memdata,
        userAttrId: userAttrId,
      };
      if (regnode) {
        axios.post("/api/login", data);
      }
      commit(types.SET_USER, data);
      return Promise.resolve(data);
    },

    /*6.3.登录成功获取会员详细信息*/
    getLoginMemDetailInfo({ commit }) {
      return http
        .post({
          fn: "mallmem.memInfoHandler.getMemDetailInfo",
          param: [],
        })
        .then((result) => {
          if (
            (result && result.success && result.target) ||
            result.target.success
          ) {
            return Promise.resolve(result);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //注销SESSION
    logoutUsrSession({ commit }, distroynode) {
      if (distroynode) {
        axios.post("/api/logout");
      }
      commit(types.SET_USER, null);
      return Promise.resolve(true);
    },

    //登录token（用于保存登录状态）
    loginToken({ commit }, data) {
      let url = Constant.loginReqUrl;
      return restCall(url, data)
        .then((res) => {
          if (res && res.success && res.target && res.target.success) {
            return Promise.resolve(res.target.target);
          } else {
            return Promise.reject(
              (res && (res.message || (res.target && res.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //18.3.通过选择属性 获取 商品单品信息
    // getGoodsSku({ commit },id) {
    //   return http.post({
    //     fn: 'mallsale.goodsHandler.getGoodsSku',
    //     param: id
    //   }).then(result => {
    //     if (result && result.success && result.target && result.target.success) {
    //       commit( GOOD_SKU, result.target.target);
    //       return Promise.resolve( result.target.target);
    //     } else {
    //       return Promise.reject(util.getResultErrMsg(result));
    //     }
    //   }).catch(error => {
    //     console.log("错误信息:", error);
    //     return Promise.reject(error);
    //   })
    // },

    /*===================================使用说明=========================================*/
    // 18.1.获取使用说明
    getElContract({ commit }, { updated = true, params = {} } = {}) {
      return http
        .post({
          fn: "mallsale.siteHandler.getAfterSalesService",
          param: [],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    // 提交问卷调查
    commitQuestionPaper({ commit }, param) {
      return http
        .post({
          fn: "mallsale.sitePaperHandler.commitPaper",
          param: [param],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result &&
                (result.message || (result.target && result.target.message))) ||
                "提交失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //分页】分页查询项目信息，关键字keyword（cpOrderId）不能为空
    pageProjects({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/api/comment/pageProjects",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //【U9】查询 订单 操作日志 信息, 入参data: CP订单号
    selectUjiuLogs({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/api/comment/selectUjiuLogs",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //【评价】添加评价
    addComment({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/api/comment/addComment",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    loginByCode({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/login/loginByCode",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    /*===================================  end  ==========================================*/
    // 获取400投诉内容
    get400Complaint({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/api/iface/getComplaint",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //400投诉处理评价-添加评价
    add400Comment({ commit }, data) {
      return tokenCall(
        Constant.commentTokenCallUrl + "/comment/api/iface/createComment",
        data
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "操作失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //微信登录部分
    //生成网页授权URL（网站应用微信登录）
    connectQrconnect({ commit }, redirectUrl) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.connectQrconnect",
          param: [redirectUrl],
        })
        .then((result) => {
          if (result && result.success && result.target) {
            return Promise.resolve(result.target);
          } else {
            if (result.message) {
              return Promise.reject(result.message);
            }
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //调用后台执行微信登录
    doWxAppLogin({ commit }, wxCode) {
      return http
        .post({
          fn: "mallmem.memLoginHandler.doWxAppLogin",
          param: [wxCode],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "登录失败！"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    [types.SET_USER](state, user) {
      state.authUser = user;
    },
  },
  getters: {
    loginType: (state) => state.loginType,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/questions/index.js